import React from "react";

const SuiviInvestissements = () => {
  return (
    <div className="suivi-investissements">
      <h2>Suivi des investissements</h2>
      <p>Tableau de bord pour suivre l'état et la performance des investissements.</p>
    </div>
  );
};

export default SuiviInvestissements;
